import React from "react";
import { IJobCardNew } from "@/common/types/Types";
import { v4 as uuidv4 } from "uuid";
import CustomTag from "../../custom-tag/CustomTag";
import { BUTTON_LABEL } from "@/common/constants/constants";

import styles from "./JobCard.module.scss";

const JobCard = (props: IJobCardNew) => {
  const { title, snippet, company, location, logo, url } = props;

  const handleClick = () => {
    window.open(url, "noopener noreferrer");
  };

  let updatedLocation = location;
  if (location.includes("{"))
    updatedLocation = JSON?.parse(location).location[0];

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h3 className={styles.position}>{title}</h3>
        <div className={styles.description}>
          {snippet?.replace(/(<([^>]+)>)/gi, "")}
        </div>
        <div className={styles.bottomSection}>
          <div className={styles.tagsWrapper}>
            <CustomTag
              key={uuidv4()}
              icon={!logo ? "/icons/briefcase-icon.svg" : logo}
              name={company}
              altIcon={company}
              backgroundColor={""}
            />
            <CustomTag
              key={uuidv4()}
              icon={"/icons/location-icon.svg"}
              name={updatedLocation}
              altIcon={updatedLocation}
              backgroundColor={""}
            />
          </div>
        </div>
      </div>
      <button className={styles.button} onClick={() => handleClick()}>
        {BUTTON_LABEL.VIEW_SALARY}
      </button>
    </div>
  );
};

export default JobCard;
